import { useEffect,useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { setVoltage } from "../redux/chartoptions";
import IndividualComponentPopup from "./individualcomponentpopup";


function Voltage(){

    const [showModal,setShowModal] = useState(false);
   

    const myData = useSelector(state => state.api);

    let current_voltage = myData.voltage[0];

        
        
        const dispatch = useDispatch();
        const checked = useSelector(state => state.chartOption.voltage)

        const showPopup = () =>{
            setShowModal(true);
        }
    
        const hidePopup = () =>{
            setShowModal(false);
        }
        

    return(
        <>
            <div className="parameter" id="voltage" onClick={showPopup}>                    
                <div className="label2">
                    <input type="checkbox" id="voltage" checked={checked} onChange={(e) => {dispatch(setVoltage(e.target.checked))}} />
                    <label htmlFor="voltage" >Voltage</label>
                </div>

                <div className="parameter_ul">
                        
                    <ul>
                        <li type="none">Current Voltage : {parseFloat(current_voltage).toFixed(2)} volts<br/> </li>
                    </ul>
                </div>
            </div>
            {showModal && <IndividualComponentPopup hider={hidePopup} bgcolor={"ffff0066"} />}
        </>
    );
}

export default Voltage;